<template>
  <div>
    <topup-auto-progress />
    <topup-auto-stage1 v-if="isStageActive(1)" />
    <topup-auto-stage2 v-if="isStageActive(2)" />
    <topup-auto-stage4 v-if="isStageActive(4)" />
  </div>
</template>

<script>
import TopupAutoProgress from '@/plus/components/Topup/Auto/Progress'
import TopupAutoStage1 from '@/plus/components/Topup/Auto/Stage1'
import TopupAutoStage2 from '@/plus/components/Topup/Auto/Stage2'
import TopupAutoStage4 from '@/plus/components/Topup/Auto/Stage4'
import TopupAutoMixin from '@/common/mixins/views/TopupAuto.mixin'

export default {
  name: 'AutoTopupView',
  mixins: [TopupAutoMixin],
  components: {
    TopupAutoStage4,
    TopupAutoStage2,
    TopupAutoStage1,
    TopupAutoProgress
  }
}
</script>
